import { useRouteError } from "react-router-dom";
import {
  FaExclamationTriangle,
  FaHome,
  FaSms,
  FaSyncAlt,
} from "react-icons/fa"; // Import icons
import { CallSharp, WhatsApp } from "@mui/icons-material";

export default function ErrorPage() {
  const error: any = useRouteError();
  console.error(error);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-50 to-gray-200 p-4">
      <div className="max-w-md w-full p-5 text-center bg-white shadow-xl rounded-lg border border-red-100 transform hover:scale-105 transition-transform duration-300 ease-in-out">
        <FaExclamationTriangle className="text-red-500 text-6xl mx-auto mb-4 animate-bounce" />{" "}
        {/* Animated Icon */}
        <h1 className="text-5xl font-extrabold text-red-700 mb-2 tracking-tight">
          Oups! Une Erreur...
        </h1>
        <p className="mt-4 text-xl text-gray-700 font-medium">
          La page que vous recherchez est introuvable ou une erreur s'est
          produite.
        </p>
        <p className="mt-2 text-md text-gray-500 italic break-words px-4">
          <span className="font-semibold text-gray-600">Code d'erreur:</span>{" "}
          {error?.status || "N/A"} -{" "}
          {error?.statusText || error?.message || "Une erreur inconnue"}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={() => window.location.reload()}
            className="flex items-center justify-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-full shadow-md hover:bg-blue-700 transition-colors duration-300 transform hover:scale-105"
          >
            <FaSyncAlt className="mr-2" /> Recharger la Page
          </button>
          <a
            href="/attote"
            className="flex items-center justify-center px-6 py-3 bg-gray-200 text-gray-800 font-semibold rounded-full shadow-md hover:bg-gray-300 transition-colors duration-300 transform hover:scale-105"
          >
            <FaHome className="mr-2" /> Retour à l'Accueil
          </a>
        </div>
        <p className="mt-6 text-sm text-gray-400">
          Si le problème persiste, veuillez nous contacter.
        </p>
        <div className="flex flex-col items-center justify-center max-h-min">
          <div className="flex items-center justify-center max-w-min">
            <a
              className="hover:cursor-pointer mx-1"
              target="_blank"
              rel="noreferrer"
              href="tel:+221781334547"
            >
              <CallSharp className="border rounded-md p-1 text-blue-500" />
            </a>
            <a
              className="hover:cursor-pointer mx-1"
              target="_blank"
              rel="noreferrer"
              href="https://api.whatsapp.com/send?phone=221781334547"
            >
              <WhatsApp className="border rounded-md text-green-500" />
            </a>
            <a
              className="hover:cursor-pointer mx-1"
              target="_blank"
              rel="noreferrer"
              href="sms:221781334547?&body=Salut Mr|Mme."
            >
              <FaSms className="border rounded-md p-1 text-blue-500 text-2xl" />
            </a>
          </div>
          <div className="my-1">
            <span className="p-1">+221 78 133 45 47</span>
          </div>
        </div>
      </div>
    </div>
  );
}
